const state = {
  faq: [],
  faq_filter: [],
  faq_id: [],
  faq_category: [],
  faq_category_id: [],
};

export default state;
